import {
  IconButton,
  MimaButton,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
  ReceiptCheckBox as RCB,
} from "../../components";
import styles from "../../assets/styles/Customer/Customer.module.scss";
import { Field, FieldArray, Formik } from "formik";
import React from "react";

const FieldInput = ({ field, ...props }) => {
  return <MimaInput {...field} {...props} />;
};

const CreateGroup = ({
  closeModal,
  customerGroupvalidationSchema,
  onSubmitCreateGroup,
  loading,
  goBack,
}) => {
  return (
    <Modal closeModal={closeModal} goBack={goBack}>
      <MimaText
        variant="subtitle"
        color="var(--color-fash-primary-3)"
        align="center"
      >
        Create Group
      </MimaText>
      <Formik
        initialValues={{
          groups: [
            {
              name: "",
              description: "",
            },
          ],
        }}
        validationSchema={customerGroupvalidationSchema}
        onSubmit={onSubmitCreateGroup}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <FieldArray name="groups">
              {({ push, remove }) => (
                <React.Fragment>
                  {values.groups.map((_, i) => (
                    <div key={i}>
                      <Field
                        name={`groups.${i}.name`}
                        id={`groups.${i}.name`}
                        component={FieldInput}
                        type="text"
                        placeholder="Group name"
                        labelTitle="Name"
                      />
                      <Field
                        name={`groups.${i}.description`}
                        id={`groups.${i}.description`}
                        component={FieldInput}
                        type="text"
                        placeholder=""
                        labelTitle="Description(optional)"
                      />

                      {i !== 0 ? (
                        <IconButton
                          variant="remove"
                          onClick={() => remove(i)}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                  <MimaButton
                    title="Add Another Group"
                    variant="outlined"
                    type="button"
                    onClick={() =>
                      push({
                        name: "",
                        description: "",
                      })
                    }
                  />
                </React.Fragment>
              )}
            </FieldArray>
            <MimaButton
              title="Continue"
              variant="regular"
              onClick={handleSubmit}
              type="submit"
              loading={loading}
              mt={2}
              width={38}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateGroup;
